<template>
  <div class="modernBox" v-if="freeItems.length">
    <div class="modernBox__title">
      <span>{{ titleText || "まずは無料で占おう！" }}</span>
    </div>
    <div class="modernBox__header">
      <span>あなたは何タイプ？TVで話題の占いを無料でおためししてみよう！</span>
    </div>
    <div class="modernBox__contents u-width-10">
      <div class="listGroup u-mg-0"
      data-color="secondary"
      data-size="lg">
        <div class="listGroup__body lateral__slide___wrapper">
          <ul class="lateral__slide">
            <li v-for="(item, index) in freeItems" class="lateral__slide__list text" data-arrow="false" :key="item.items_id">
              <a class="lateral__slide__link"
              :href="`${item.url}?top_free=${index + 1}`"
              :data-items-id="item.items_id"
              >
                <div class="lateral__slide__image" data-size="xm" data-clip-path-support="true">
                  <img data-clip-path-support="true" data-size="xm" size="xm" :src="item.pack_image">
                </div>
            
                <div class="lateral__slide__text">
                  <div class="media__content">
                    <div class="lateral__slide__title__wrapper">
                      <span class="lateral__slide__title">{{item.item_name}}</span>
                    </div>
                  </div>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'freeitems-list',
  data() {
    return {
      freeItems: [],

    };
  },
  props: {
    titleText: String,
  },
  mounted() {
    axios.post('/api/items/free/list').then(res => {
      this.freeItems = res.data.free_items
    })
  },
  methods: {
  }
};
</script>
<style lang="scss" scoped>
//横スライド
.lateral__slide___wrapper {
  overflow-x: scroll;
  overflow-y: hidden;
}
.lateral__slide {
  display: flex;
  -webkit-box-align: start;
  align-items: flex-start;
  margin: 0;
  padding: 0 16px;
  list-style: none;
  height: 186px;
  padding: 0 12px;
}
.lateral__slide__list {
  position: relative;
  &:nth-of-type(n + 2) {
    margin-left: 8px;
  }
  &:last-child {
    padding-right: 8px;
  }
}
.lateral__slide__link {
  text-decoration: none;
}
.lateral__slide__image {
  height: 96px;
  width: 96px;
  img {
    height: 96px;
    width: 96px;
    border-radius: 6px;
  }
}

.lateral__slide__text {
  margin-top: 8px;
}
.lateral__slide__title__wrapper {
  overflow: hidden;
}
.lateral__slide__title {
  font-size: 11px;
  line-height: 14px;
  letter-spacing: 0.08em;
  margin: 0;
  width: 96px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/FreeitemsList.vue